/* ======================================================================== */
/* 6. elementor */
/* ======================================================================== */
/**
 * Elementor Widgets
 */
$(window).on('elementor/frontend/init', function () {

	elementorFrontend.hooks

		/**
		 * Feature
		 */
		.addAction('frontend/element_ready/arrigo-widget-feature.default', function ($scope) {

			function loadComponent() {
				new FigureFeature($scope);
			}
			window.fontPrimaryObserver.then(loadComponent, loadComponent);

		})

		/**
		 * Portfolio Slider Fullscreen 1
		 */
		.addAction('frontend/element_ready/arrigo-widget-portfolio-slider-fullscreen-1.default', function ($scope) {

			function loadComponent() {
				new Button();
				new SliderFullscreen1($scope);
				new SectionFullscreen1($scope);
			}
			window.fontPrimaryObserver.then(loadComponent, loadComponent);

		})

		/**
		 * Portfolio Slider Fullscreen 2
		 */
		.addAction('frontend/element_ready/arrigo-widget-portfolio-slider-fullscreen-2.default', function ($scope) {

			function loadComponent() {
				new Button();
				new SliderFullscreen4($scope);
				new SectionFullscreen4($scope);
				new Social();
			}
			window.fontPrimaryObserver.then(loadComponent, loadComponent);

		})

		/**
		 * Figure Portfolio
		 */
		.addAction('frontend/element_ready/arrigo-widget-portfolio-grid-irregular.default', function ($scope) {

			function loadComponent() {
				new FigurePortfolio($scope);
			}
			window.fontPrimaryObserver.then(loadComponent, loadComponent);

		})

		/**
		 * Masonry Grid
		 */
		.addAction('frontend/element_ready/arrigo-widget-masonry-grid.default', function ($scope) {

			function loadComponent() {
				new Grid($scope);
			}
			window.fontPrimaryObserver.then(loadComponent, loadComponent);

		})

		/**
		 * Masonry Grid Portfolio
		 */
		.addAction('frontend/element_ready/arrigo-widget-portfolio-masonry-grid.default', function ($scope) {

			function loadComponent() {
				new Grid($scope);
			}
			window.fontPrimaryObserver.then(loadComponent, loadComponent);

		})

		/**
		 * Shortcode
		 */
		.addAction('frontend/element_ready/shortcode.default', function ($scope) {

			function loadComponent() {
				new Form();
			}
			window.fontPrimaryObserver.then(loadComponent, loadComponent);

		})

		/**
		 * Services Grid
		 */
		.addAction('frontend/element_ready/arrigo-widget-services-grid.default', function ($scope) {

			function loadComponent() {
				new SectionFeatures($scope);
				new FigureFeature($scope);
			}
			window.fontPrimaryObserver.then(loadComponent, loadComponent);

		})

		/**
		 * Services Slider
		 */
		.addAction('frontend/element_ready/arrigo-widget-services-slider.default', function ($scope) {

			function loadComponent() {
				new SliderServices($scope);
				new FigureService($scope);
			}
			window.fontPrimaryObserver.then(loadComponent, loadComponent);

		})

		/**
		 * Google Map
		 */
		.addAction('frontend/element_ready/arrigo-widget-google-map.default', function ($scope) {

			function loadComponent() {
				new GMap($scope);
			}
			window.fontPrimaryObserver.then(loadComponent, loadComponent);

		})

		/**
		 * CTA
		 */
		.addAction('frontend/element_ready/arrigo-widget-cta.default', function ($scope) {

			function loadComponent() {
				objectFitImages();
				new Parallax($scope);
				new SectionCTA($scope);
			}
			window.fontPrimaryObserver.then(loadComponent, loadComponent);

		})

		/**
		 * Header Section
		 */
		.addAction('frontend/element_ready/arrigo-widget-header-section.default', function ($scope) {

			function loadComponent() {
				new SectionHeader($scope);
			}
			window.fontPrimaryObserver.then(loadComponent, loadComponent);

		})

		/**
		 * Masthead Intro
		 */
		.addAction('frontend/element_ready/arrigo-widget-masthead-intro.default', function ($scope) {

			function loadComponent() {
				new SectionIntro($scope);
			}
			window.fontPrimaryObserver.then(loadComponent, loadComponent);

		})

		/**
		 * Parallax Background
		 */
		.addAction('frontend/element_ready/arrigo-widget-parallax-background.default', function ($scope) {

			function loadComponent() {
				new Parallax($scope);
			}
			window.fontPrimaryObserver.then(loadComponent, loadComponent);

		})

		/**
		 * Step
		 */
		.addAction('frontend/element_ready/arrigo-widget-step.default', function ($scope) {

			function loadComponent() {
				new SectionSteps($scope);
				new Parallax($scope);
			}
			window.fontPrimaryObserver.then(loadComponent, loadComponent);

		})

		/**
		 * Testimonials Slider
		 */
		.addAction('frontend/element_ready/arrigo-widget-testimonials-slider.default', function ($scope) {

			function loadComponent() {
				new SliderTestimonials($scope);
			}
			window.fontPrimaryObserver.then(loadComponent, loadComponent);

		})

		/**
		 * Latest Posts
		 */
		.addAction('frontend/element_ready/arrigo-widget-latest-posts.default', function ($scope) {

			function loadComponent() {
				new FigurePost($scope);
			}
			window.fontPrimaryObserver.then(loadComponent, loadComponent);

		})

		/**
		 * Team Member
		 */
		.addAction('frontend/element_ready/arrigo-widget-team-member.default', function ($scope) {

			function loadComponent() {
				new Social();
			}
			window.fontPrimaryObserver.then(loadComponent, loadComponent);

		})

		/**
		 * Images Slider
		 */
		.addAction('frontend/element_ready/arrigo-widget-images-slider.default', function ($scope) {

			function loadComponent() {
				new SliderPortfolioItem($scope);
			}
			window.fontPrimaryObserver.then(loadComponent, loadComponent);

		})

		/**
		 * Featured Image
		 */
		.addAction('frontend/element_ready/arrigo-widget-featured-image.default', function ($scope) {

			function loadComponent() {
				new Parallax($scope);
			}
			window.fontPrimaryObserver.then(loadComponent, loadComponent);

		});

});
